<template>
	<div class="full">
		<vxe-grid ref="bIshopgoodsoperate" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<add-index ref="addIndex" :row="row" :key="modealKey" @submit="submit" />
	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 70%;
	}

	.footer {
		position: relative;
		width: 100%;
		height: 30%;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import addIndex from './add.vue'
	export default {
		mixins: [listMixins],
		name: 'bi',
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				tableData: [],
				list_formConfig: [],
				modealKey: Math.random()
			}
		},
		watch: {
			row() {
				
				this.modealKey = Math.random()
				this.reload()
			}
		},
		created() {

		},
		mounted() {
			// this.gridOptions = this.getOption()
			// console.log(this.gridOptions)
		},
		computed: {

		},
		methods: {
			submit() {
				this.reload()
			},
			reload() {
				this.$refs.bIshopgoodsoperate.commitProxy('query')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = 'bIshopgoodsoperate'
				gridOptions.showOverflow = false
				gridOptions.columns = this.getColumns()
				gridOptions.tooltipConfig.contentMethod = this.contentMethod
				gridOptions.toolbarConfig.buttons = [{
						name: '新增',
						status: 'primary',
						code: 'add'
					},
					{
						name: '跟进',
						status: 'danger',
						code: 'flowup'
					}
				]
				gridOptions.pagerConfig = {
					enabled: false,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500, 5000],
				}
			},
			list(page, form) {
				return new Promise((resolve) => {
					this.$api.BIshopgoods.getOperate({
						...page,
						...form,
						goodscode: this.row.code
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve()
					})
				})
			},
			getColumns() {
				let columns = [{
						field: '',
						title: '',
						type: 'checkbox',
						width: 50,
					},
					{
						field: 'staffid',
						title: '操作人',
						formatter: ({
							row
						}) => {
							return window.systemMethods.getstaff(row.staffid)
						}
					},
					{
						field: 'type',
						title: '类型',
						formatter: ({
							row
						}) => {
							let map = ['','运营','推广']
							return map[row.type]
						}
					},
					{
						field: 'content',
						title: '操作内容',
					},
					{
						field: 'flowupcount',
						title: '跟进次数',
					},
					{
						field: 'flowuptime',
						title: '最近跟进时间',
						formatter: ({
							row
						}) => {
							return window.systemMethods.timestampToDate(row.flowuptime, true)
						}
					},
					{
						field: 'flowupremind',
						title: '跟进提醒',
						cellRender : {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'是',
								closeLabel:'否',
								openValue:1,
								closeValue:0,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.flowupremindChange(row)
								}
							}
						}
					},
					{
						field: 'create_time',
						title: '创建时间',
						formatter: ({
							row
						}) => {
							return window.systemMethods.timestampToDate(row.create_time, true)
						}
					},
					{
						title: '操作',
						width:70,
						align:'center',
						slots: {
							default:({row})=>{
								return <el-button size="mini" type="text" style="font-size:12px;color:#F56C6C" onClick={()=>{this.delete(row)}}>删除</el-button>
							}
						}
					}
				]
				return columns
			},
			add() {
				if (!this.row) {
					return this.$message.error('请选择商品')
				}
				this.$refs.addIndex.modal_show()
			},
			flowup() {
				let ids = []
				let data = this.$refs.bIshopgoodsoperate.getCheckboxRecords()
				if (data.length == 0) {
					return this.$message.error('请选择操作明细')
				}
				this.$confirm('是否确认跟进？','提示').then(()=>{
					data.forEach((item)=>{
						ids.push(item.id)
					})
					this.$api.BIshopgoods.operateFlowup({ids:ids}).then(() => {
						this.$message.success('操作成功')
						this.reload()
					})
				})
			},
			flowupremindChange(row){
				this.$api.BIshopgoods.operateUpdate({id:row.id,flowupremind:row.flowupremind}).then(() => {
					this.$message.success('操作成功')
				})
			},
			delete(row){
				this.$confirm('是否确认删除？','提示').then(()=>{
					this.$api.BIshopgoods.operateDelete({id:row.id}).then(() => {
						this.$message.success('操作成功')
						this.reload()
					})
				})
			},
		},
		components: {
			addIndex
		}
	}
</script>